import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.number.parse-int.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.typed.uint8-array.js";
import { DecodeUTF8, Decompress } from 'fflate';
import SampleValidationError from 'utils/errors/upload/SampleValidationError';
import { decode, decompress } from 'utils/upload/decompressionUtils';
var errorMessages = {
  invalidBarcodesFile: function invalidBarcodesFile(expected, found) {
    return "Invalid barcodes.tsv file: ".concat(expected, " barcodes expected, but ").concat(found, " found.");
  },
  invalidFeaturesFile: function invalidFeaturesFile(expected, found) {
    return "Invalid features/genes.tsv file: ".concat(expected, " genes expected, but ").concat(found, " found.");
  },
  transposedMatrixFile: function transposedMatrixFile() {
    return 'Invalid matrix.mtx file: Matrix is transposed.';
  },
  missingFiles: function missingFiles(_missingFiles) {
    return "Incomplete sample: Sample does not contain \"".concat(_missingFiles.join('" and "'), "\" file(s). Please include the file in the sample.");
  },
  invalidMatrixFormat: function invalidMatrixFormat(type) {
    var errMessage = 'Invalid matrix.mtx file: Invalid matrix format type';
    if (type === 'array') errMessage = 'Invalid matrix.mtx file: Matrix file format is "array". Please convert to sparse "coordinate" format.';
    return errMessage;
  }
};
var CHUNK_SIZE = Math.pow(2, 18); // 256 kB

var extractSampleSizes = function extractSampleSizes(matrixHead) {
  // The size line is the first line in the file that does not begin with a comment (%)
  var sizeLine = matrixHead.split('\n').find(function (line) {
    return line[0] !== '%';
  });
  var _sizeLine$split = sizeLine.split(' '),
    _sizeLine$split2 = _slicedToArray(_sizeLine$split, 3),
    featuresSize = _sizeLine$split2[0],
    barcodeSize = _sizeLine$split2[1],
    matrixSize = _sizeLine$split2[2];
  return [Number.parseInt(featuresSize, 10), Number.parseInt(barcodeSize, 10), Number.parseInt(matrixSize, 10)];
};
var getNumLines = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(sampleFile) {
    var compressed, fileObject, numLines, utfDecode, dcmpStrm, decoder, idx, _slice, finalSlice;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            compressed = sampleFile.compressed, fileObject = sampleFile.fileObject;
            numLines = 0; // Streaming UTF-8 decoder
            utfDecode = new DecodeUTF8(function (data) {
              numLines += (data.match(/\n|\r\n/g) || []).length;
            }); // Streaming Decompression (auto-detect the compression method)
            dcmpStrm = new Decompress(function (chunk, final) {
              utfDecode.push(chunk, final);
            }); // if the file is compressed we use the decompressor on top of the utfDecoder
            // otherwise, just use the utfDecoder
            decoder = compressed ? dcmpStrm : utfDecode;
            idx = 0;
          case 6:
            if (!(idx + CHUNK_SIZE < fileObject.size)) {
              _context.next = 14;
              break;
            }
            _context.next = 9;
            return fileObject.slice(idx, idx + CHUNK_SIZE).arrayBuffer();
          case 9:
            _slice = _context.sent;
            decoder.push(new Uint8Array(_slice));
            idx += CHUNK_SIZE;
            _context.next = 6;
            break;
          case 14:
            _context.next = 16;
            return fileObject.slice(idx, fileObject.size).arrayBuffer();
          case 16:
            finalSlice = _context.sent;
            decoder.push(new Uint8Array(finalSlice), true);
            return _context.abrupt("return", numLines);
          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getNumLines(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getMatrixHead = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(matrix) {
    var compressed, fileObject, matrixHeader, fileArrBuffer;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            compressed = matrix.compressed, fileObject = matrix.fileObject;
            matrixHeader = '';
            _context2.next = 4;
            return fileObject.slice(0, 300).arrayBuffer();
          case 4:
            fileArrBuffer = _context2.sent;
            if (!compressed) {
              _context2.next = 15;
              break;
            }
            _context2.t1 = decode;
            _context2.next = 9;
            return decompress(fileArrBuffer);
          case 9:
            _context2.t2 = _context2.sent;
            _context2.next = 12;
            return (0, _context2.t1)(_context2.t2);
          case 12:
            _context2.t0 = _context2.sent;
            _context2.next = 18;
            break;
          case 15:
            _context2.next = 17;
            return decode(fileArrBuffer);
          case 17:
            _context2.t0 = _context2.sent;
          case 18:
            matrixHeader = _context2.t0;
            return _context2.abrupt("return", matrixHeader);
          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function getMatrixHead(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var validateSampleCompleteness = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(sampleFiles) {
    var barcodes10x, features10x, matrix10x, missingFiles;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            barcodes10x = sampleFiles.barcodes10x, features10x = sampleFiles.features10x, matrix10x = sampleFiles.matrix10x;
            missingFiles = [];
            if (!barcodes10x) missingFiles.push('barcodes');
            if (!features10x) missingFiles.push('features');
            if (!matrix10x) missingFiles.push('matrix');
            if (!missingFiles.length) {
              _context3.next = 7;
              break;
            }
            throw new SampleValidationError(errorMessages.missingFiles(missingFiles));
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function validateSampleCompleteness(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
var validateMatrixFormat = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(sampleFiles) {
    var matrix10x, matrixHead, headerLine;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            matrix10x = sampleFiles.matrix10x;
            _context4.next = 3;
            return getMatrixHead(matrix10x);
          case 3:
            matrixHead = _context4.sent;
            // Reject sample if type of count matrix is "array" not "coordinate"
            // See https://networkrepository.com/mtx-matrix-market-format.html
            headerLine = matrixHead.split('\n')[0];
            if (!headerLine.match('array')) {
              _context4.next = 7;
              break;
            }
            throw new SampleValidationError(errorMessages.invalidMatrixFormat('array'));
          case 7:
            if (headerLine.match('coordinate')) {
              _context4.next = 9;
              break;
            }
            throw new SampleValidationError(errorMessages.invalidMatrixFormat());
          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function validateMatrixFormat(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
var validateFileSizes = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(sampleFiles) {
    var barcodes10x, features10x, matrix10x, errors, matrixHead, _extractSampleSizes, _extractSampleSizes2, expectedNumFeatures, expectedNumBarcodes, numBarcodesFound, numFeaturesFound;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            barcodes10x = sampleFiles.barcodes10x, features10x = sampleFiles.features10x, matrix10x = sampleFiles.matrix10x;
            errors = [];
            _context5.next = 4;
            return getMatrixHead(matrix10x);
          case 4:
            matrixHead = _context5.sent;
            _extractSampleSizes = extractSampleSizes(matrixHead), _extractSampleSizes2 = _slicedToArray(_extractSampleSizes, 2), expectedNumFeatures = _extractSampleSizes2[0], expectedNumBarcodes = _extractSampleSizes2[1];
            _context5.next = 8;
            return getNumLines(barcodes10x);
          case 8:
            numBarcodesFound = _context5.sent;
            _context5.next = 11;
            return getNumLines(features10x);
          case 11:
            numFeaturesFound = _context5.sent;
            if (numBarcodesFound === expectedNumFeatures && numFeaturesFound === expectedNumBarcodes) {
              errors.push(errorMessages.transposedMatrixFile());
            }
            if (numBarcodesFound !== expectedNumBarcodes) {
              errors.push(errorMessages.invalidBarcodesFile(expectedNumBarcodes, numBarcodesFound));
            }
            if (numFeaturesFound !== expectedNumFeatures) {
              errors.push(errorMessages.invalidFeaturesFile(expectedNumFeatures, numFeaturesFound));
            }
            if (!errors.length) {
              _context5.next = 17;
              break;
            }
            throw new SampleValidationError(errors.join('\n'));
          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function validateFileSizes(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
var validate10x = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(sample) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return validateSampleCompleteness(sample.files);
          case 2:
            _context6.next = 4;
            return validateMatrixFormat(sample.files);
          case 4:
            _context6.next = 6;
            return validateFileSizes(sample.files);
          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return function validate10x(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export default validate10x;